import React from 'react';
import { useRouter } from 'next/router';
import { ORIGIN } from 'src/constants';
import useSnackbar from './SnackBar/useSnackbar';
import HeaderButton from './HeaderButton';
import shareIcon from '../public/images/share.svg';

const ShareButton: React.FC = () => {
  const { showSuccess } = useSnackbar();
  const router = useRouter();
  const handleShare = () => {
    navigator.clipboard.writeText(`${ORIGIN}${router.asPath}`);
    showSuccess({ message: 'Link copied' });
  };
  return (
    <HeaderButton
      icon={shareIcon}
      alt="share"
      label="Share"
      onClick={handleShare}
      tooltip="Share"
    />
  );
};

export default ShareButton;
